<template>
    <solid-box
        :priceRate="tradeSum.priceRate[transferVariety]"
        :title="moduleName"
    >
        <!-- 2022-07-27 针对湖南线上大屏做的特殊处理 -->
        <template v-if="$route.params.id === hnLocId">
            <div class="count-list">
                <div class="item -one">
                    <div class="title">成交金额</div>
                    <div class="text">
                        17662.68<span class="unit">万元</span>
                    </div>
                </div>
                <div class="item -two">
                    <div class="title">成交宗数</div>
                    <div class="text">2282<span class="unit">宗</span></div>
                </div>
            </div>
            <div class="count-list -single">
                <div class="item -three">
                    <div class="title">平均年租金</div>
                    <div class="text">4100<span class="unit">元/宗</span></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="count-list">
                <div class="item -one">
                    <div class="title">{{ tradeSum.ctype }}面积</div>
                    <div class="text">
                        {{ tradeSum.area.zjd || 0 }}
                        <!-- <scroll-number :value="tradeSum.area.zjd || 0"></scroll-number> -->
                        <span class="unit">平方米</span>
                    </div>
                </div>
                <div class="item -two">
                    <div class="title">{{ tradeSum.ctype }}笔数</div>
                    <div class="text">
                        {{ $toTnteger(tradeSum.count.zjd) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="count-list -single">
                <div class="item -three">
                    <div class="title">{{ tradeSum.ctype }}金额</div>
                    <div class="text">
                        {{
                            tradeSum.money[`tradeAmount_${transferVariety}`] ||
                                0
                        }}<span class="unit">万元</span>
                    </div>
                </div>
            </div>
        </template>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
// import ScrollNumber from '@/components/ScrollNumber'
import env from '@/config/env'

/**
 * 农村宅基地和住房
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        },
        moduleName: {
            type: String,
            default: ''
        },
        transferVariety: {
            type: String,
            default: ''
        }
    },
    components: {
        SolidBox,
        // ScrollNumber
    },
    data() {
        return {
            hnLocId: env.HNLOCID
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 450px;
    height: 215px;
    margin: 17px auto 0;
}

.count {
    font-size: 22px;
    line-height: 30px;
    position: absolute;
    bottom: 42px;
    right: 38px;
    color: #fff;

    > .number {
        color: #ffa106;
        font-size: 40px;
        font-weight: bold;
    }
}

.count-list {
    padding: 36px 50px 0;
    display: flex;
    justify-content: space-between;

    &.-single {
        justify-content: center;
        padding-top: 53px;
    }

    > .item {
        padding-left: 70px;
        background-size: 63px 60px;
        background-position: left center;
        background-repeat: no-repeat;

        &.-one {
            background-image: url('../../../assets/images/rha_one.png');
        }

        &.-two {
            background-image: url('../../../assets/images/rha_two.png');
        }

        &.-three {
            background-image: url('../../../assets/images/rha_three.png');
        }

        > .title {
            font-size: 18px;
            line-height: 25px;
            color: #ffffff;
            text-shadow: 0 2px 4px rgba(255, 255, 255, 0.5);
        }

        > .text {
            display: flex;
            align-items: center;
            font-size: 30px;
            color: #fff;
            text-shadow: 0 2px 4px rgba(255, 255, 255, 0.5);
            font-weight: bold;
            white-space: nowrap;
            // line-height: 44px;
            letter-spacing: -2px;

            > .up {
                font-size: 20px;
                vertical-align: text-top;
            }

            > .unit {
                font-size: 30px;
                margin-left: 5px;
                font-weight: normal;
            }
        }
    }
}
</style>
